import type { MinifiedGlobalPageSettings } from '~~/lib/ContentfulGraphqlService';
import { isStoreConfigRequiredRoute } from '~/utils/shop/isStoreConfigRequiredRoute';

type ShopConfig = NonNullable<MinifiedGlobalPageSettings['shopConfig']>;

export function shouldLoadMagentoStoreConfig(options: {
  pathname: string;
  shopConfig: ShopConfig | null | undefined;
  locale: string;
  isServer: boolean;
  hasStoreCode: boolean;
}): boolean {
  if (options.locale === 'zh-cn') {
    return false;
  }

  if (!isStoreConfigRequiredRoute(options.pathname, options.shopConfig)) {
    return false;
  }

  if (options.isServer) {
    return true;
  }

  return !options.hasStoreCode;
}
